import { Component, OnInit } from '@angular/core';
import { Faculty } from 'src/app/models/faculty.model';
import { FacultyService } from 'src/app/services/faculty/faculty.service';

@Component({
  selector: 'app-microbilogy',
  templateUrl: './microbilogy.component.html',
  styleUrls: ['./microbilogy.component.scss']
})
export class MicrobilogyComponent implements OnInit {
  micro:Faculty[];
  constructor(private facultyService:FacultyService) { }

  ngOnInit(): void {
    this.micro=this.facultyService.getMicrobiology();
  }

}
